import { checkLocationGroupRequired } from './rules.js';
import { locationFormFieldsSchema, withNameAndDescriptionRefinements } from './update-form.js';
export const locationCreateSchema = locationFormFieldsSchema.superRefine((values, context) => {
    withNameAndDescriptionRefinements(values, context);
    for (const issue of checkLocationGroupRequired(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
//# sourceMappingURL=create-form.js.map